export enum UnsavedEmailsEnum {
  create_rule_email = 'create_rule_email',
  create_rule_email_with_recipient = 'create_rule_email_with_recipient',
  create_funnel_email = 'create_funnel_email',
}
